import React, { FC, useContext } from 'react';
import { graphql } from 'gatsby';
import { getLinkPath } from '@lucid/gatsby-theme-lucid';
import { css } from '@emotion/core';

import {
  Drupal_ParagraphListOfLinks,
  Drupal_ParagraphLink
} from '../../generated/graphql';
import Link from '../link/link';
import LayoutContext from '../../contexts/layoutContext';

interface Props {
  entity: Drupal_ParagraphListOfLinks;
  columnSize?: number;
}

const ListOfLinks: FC<Props> = ({ entity, columnSize, ...rest }) => {
  const { fieldHeader, fieldLinkData } = entity;
  const {
    language: { langPrefix }
  } = useContext(LayoutContext);

  const columns = columnSize
    ? Math.floor(fieldLinkData?.length! / columnSize) + 1
    : 1;

  return (
    <div css={css({ marginBottom: '1rem', padding: '0 1rem' })} {...rest}>
      <p css={css({ fontWeight: 'bold', margin: '0 0 1.5rem' })}>
        {fieldHeader}
      </p>
      <ul
        css={theme =>
          css({
            columns,
            listStyle: 'none',
            margin: 0,
            [`@media screen and (max-width: ${theme.breakpoints[4]})`]: {
              columns: 1
            }
          })
        }
      >
        {fieldLinkData
          ?.filter(linkData => linkData?.entity?.entityTranslation)
          .map(linkData => {
            const { entityId, fieldCta } = linkData?.entity
              ?.entityTranslation as Drupal_ParagraphLink;

            return (
              <li key={entityId!} css={css({ margin: '0 0 1.5rem' })}>
                <Link to={getLinkPath(fieldCta?.url, langPrefix)}>
                  {fieldCta?.title}
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default ListOfLinks;

export const query = graphql`
  fragment listOfLinks on Drupal_ParagraphListOfLinks {
    fieldHeader
    fieldLinkData {
      entity {
        entityTranslation(language: $LanguageId) {
          ... on Drupal_ParagraphLink {
            entityId
            fieldCta {
              title
              url {
                ...getLinkPath
              }
            }
          }
        }
      }
    }
  }
`;
